<template>
  <div class="google-map">
    <input id="location-input" />
    <div id="gmp-map"></div>
  </div>
</template>

<script>
import { GoogleConfiguration } from '@/helpers/Constants';

export default {
  name: "google-map",
  computed: {
    geoLocation() {
      return this.$store.state.geoLocation;
    },
  },
  watch: {
    geoLocation(place) {
      console.log('geoLocation', this.$store.state.geoLocation);
      console.log('render', this.renderAddress);
      this.renderAddress(place?.geometry?.location);
    }
  },
  data() {
    return {
      renderAddress: null
    };
  },
  mounted() {
    const that = this;
    window.initMap = function() {
      console.log('Google Map script loading');
      const getFormInputElement = (component) => document.getElementById(component + '-input');
      /* eslint-disable no-undef */
      const map = new google.maps.Map(document.getElementById("gmp-map"), {
        zoom: GoogleConfiguration.mapOptions.zoom,
        center: GoogleConfiguration.mapOptions.center,
        mapTypeControl: false,
        fullscreenControl: true,
        zoomControl: true,
        streetViewControl: false,
        mapId: GoogleConfiguration.mapOptions.mapId || 'PROCON_MAP_ID',
      });
      const marker = new google.maps.marker.AdvancedMarkerElement({ map: map });
      const autocompleteInput = getFormInputElement('location');
      const autocomplete = new google.maps.places.Autocomplete(autocompleteInput, {
        fields: ["geometry", "name"],
        types: ["address"],
      });
      /* eslint-enable no-undef */
      autocomplete.addListener('place_changed', function() {
        console.log('place_changed');
        marker.visible = false;
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and pressed the Enter key, or the Place Details request failed.
          window.alert('No details available for input: \'' + place.name + '\'');
          return;
        }
        that.$store.commit('geoLocation', place);
      });

      that.renderAddress = function renderAddress(location) {
        try {
          map.setCenter(location || GoogleConfiguration.mapOptions.center);
          map.setZoom(GoogleConfiguration.mapOptions.zoom);
          marker.position = location;
          marker.visible = true;
          console.log(location);
        } catch (error) {
          console.error(error);
        }
      };

      console.log('Google Map script loaded');
    };

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GoogleConfiguration.mapsApiKey}&libraries=places,marker&callback=initMap&loading=async`;
    document.head.appendChild(script);
  }
};
</script>

<style lang="scss">
  .google-map {
    display: none;
  }
</style>
